import React, { useEffect, useState } from "react";
import Input from "../../../../components/FormElement/Search";
import { useFormik } from "formik";
import { FormWrapper } from "../style";
import Button from "../../../../components/FormElement/Button";
import { useHideModal } from "../../../../hooks";
import * as Yup from "yup";
import service from "../../../../services/projectCategory";
import LangTab from "../../../../components/FormElement/LangTab";
import { useShowAlert } from "../../../../hooks/useAlerts";
import Spinner from "../../../../components/Spinner/FullScreen";

function Form({ state, refreshData }) {
  const { hideModal } = useHideModal();
  const { error } = useShowAlert();
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("UZL");

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
  });
  const formik = useFormik({
    initialValues: {
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        ...values,
      };
      setLoading(true);
      if (state) {
        service
          .update(state, payload)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(payload)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (state) {
      setLoading(true);
      service
        .getOne(state)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp?.title?.UZL,
              UZK: resp?.title?.UZK,
              RUS: resp?.title?.RUS,
              ENG: resp?.title?.ENG,
            },
          });
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [state]);

  const onLangChange = (key) => {
    setLanguage(key);
  };
  if (loading) return <Spinner />;
  return (
    <FormWrapper>
      <form onSubmit={formik.handleSubmit}>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <Input
          id="title"
          label="Loyiha kategoriyasi"
          name="title"
          width={100}
          placeholder="Loyiha kategoriya nomi"
          onChange={(e) => {
            formik.setFieldValue(`title.${language}`, e.target.value);
          }}
          value={formik.values?.title[language]}
          status={formik?.errors?.title && formik.touched.title ? "error" : ""}
        />
        <Button
          className="sendBtn"
          htmlType="submit"
          text={state ? "Yangilash" : "Qo'shish"}
          width="100%"
        />
      </form>
    </FormWrapper>
  );
}

export default Form;
